<template>
	<div v-if="!isEmpty(filteredItems)">
		<div v-for="(value, key, index) in filteredItems" :key="key" class="menu-items-container mb-1">
			<DataInputTableItem
				v-if="isTable(value)"
				v-on="$listeners"
				:class="{ 'is-disabled': preventTables }"
				:item="item"
				:value="value"
				:itemKey="key"
				:ref="key + index"
				:stepIndex="stepIndex"
				:searchString="searchString"
				:useWithFormulas="useWithFormulas"
				:contentRectYAxis="contentRectYAxis"
				:focusedMenuItemKey="focusedMenuItemKey"
				:isTableOnly="isTableOnly || allowTableSelection"
				:didFocusFromBottomToTop="didFocusFromBottomToTop"
			/>
			<DataInputMenuItem
				v-else
				v-on="$listeners"
				:ref="`DataInputMenuItem-${key}`"
				:item="item"
				:value="value"
				:itemKey="key"
				:stepIndex="stepIndex"
				:dataInputParam="dataInputParam"
				:isTableOnly="isTableOnly"
				:searchString="searchString"
				:contentRectYAxis="contentRectYAxis"
				:focusedMenuItemKey="focusedMenuItemKey"
			/>
			<div class="info-icon"><AppInfoTooltipIcon v-if="preventTables" :left="true" max-width="200px" :text="iconTooltip" /></div>
		</div>
	</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

import { isArrayOfObjects } from '@/utils/helpers';

import DataInputMenuItem from './DataInputMenuItem';
import DataInputTableItem from './DataInputTableItem';

export default {
	name: 'DataInputMenuItems',
	props: {
		item: { type: Object },
		stepIndex: { type: Number },
		isTableOnly: { type: Boolean },
		searchString: { type: String },
		filteredItems: { type: Object },
		useWithFormulas: { type: Boolean },
		contentRectYAxis: { type: Number },
		dataInputParam: { type: Object },
		focusedMenuItemKey: { type: String },
		allowTableSelection: { type: Boolean },
		didFocusFromBottomToTop: { type: Boolean },
		preventTables: { type: Boolean },
	},
	components: {
		DataInputMenuItem,
		DataInputTableItem,
	},
	data() {
		return {
			iconTooltip: 'Add a table function helper before this step to use a value from this table',
		};
	},
	computed: {
		getAllTableRefs() {
			return Object.keys(this.$refs || {});
		},
	},
	methods: {
		selectFocusedItem() {
			// Called from Parent
			if (this.dataInputParam?.format) {
				Object.entries(this.$refs).forEach(([key, [refCmp]]) => {
					if (key.includes('DataInputMenuItem-')) {
						refCmp.openFormulasMenu();
					}
				});
			} else {
				this.passEventToTableItems('selectFocusedItem');
			}
		},
		focusOnNextMenuItem() {
			// Called from Parent
			this.passEventToTableItems('focusOnNextMenuItem');
		},
		focusOnPreviousMenuItem() {
			// Called from Parent
			this.passEventToTableItems('focusOnPreviousMenuItem');
		},
		selectTableColumn() {
			// called from parent
			this.passEventToTableItems('selectTableColumn');
		},
		passEventToTableItems(funcName) {
			this.$nextTick(() => {
				this.getAllTableRefs.map((tableRef) => {
					this.$refs &&
						this.$refs[tableRef] &&
						this.$refs[tableRef][0] &&
						this.$refs[tableRef][0][funcName] &&
						this.$refs[tableRef][0][funcName]();
				});
			});
		},
		isEmpty(value) {
			return isEmpty(value);
		},
		isTable(value) {
			return Array.isArray(value) || isArrayOfObjects(value);
		},
		highlightMenuMessage() {
			this.$emit('highlight-menu-message');
		},
	},
};
</script>

<style scoped lang="scss">
.menu-items-container {
	position: relative;

	&:hover {
		.info-icon ::v-deep(svg) {
			path {
				fill: var(--primary-color) !important;
			}
			circle {
				stroke: var(--primary-color) !important;
			}
		}
	}
	.info-icon {
		position: absolute;
		top: 35px;
		right: 15px;
	}
}
</style>
